export const SUCCESS_POPUP_TYPE = {
  CLAIMED: 'claimed',
  DEPOSITED: 'deposited',
  REFUNDED: 'refunded'
}
